
import { Component, Vue } from 'vue-property-decorator';
import { sections } from '@/components/layout';
import SectionScroll from '@/components/SectionScroll.vue';

@Component({
  components: { ...sections, SectionScroll }
})
export default class HomeComponent extends Vue {}
